import { type ReactNode } from "react"

interface Props {
  heading: string
  children: ReactNode
}

export function CareCard({ heading, children }: Props): JSX.Element {
  return (
    <div className="nhsuk-card nhsuk-card--care nhsuk-card--care--non-urgent" key={heading}>
      <div className="nhsuk-card--care__heading-container">
        <h2 className="nhsuk-card--care__heading">
          <span>
            <span className="nhsuk-u-visually-hidden">Non-urgent advice: </span>
            {heading}
          </span>
        </h2>
        <span className="nhsuk-card--care__arrow" aria-hidden="true"></span>
      </div>
      <div className="nhsuk-card__content">{children}</div>
    </div>
  )
}
